import { all, fork } from 'redux-saga/effects';
import appStartupSaga from './app/app-sagas';
import clipStartupSaga from './clip/clip-sagas';
import topicStartupSaga from './topic/topic-sagas';
import listStartupSaga from './list/list-sagas';
import playbackPageSaga from 'data/playback-page/playback-page-sagas';
import landingPageStartupSaga from './landing-page/landing-page-sagas';
import searchStartupSaga from './search/search-sagas';

export default function* rootSaga() {

    yield all([
        fork(appStartupSaga),
        fork(clipStartupSaga),
        fork(topicStartupSaga),
        fork(listStartupSaga),
        fork(playbackPageSaga),
        fork(landingPageStartupSaga),
        fork(searchStartupSaga),
    ]);

}
